import { render, staticRenderFns } from "./LinkChurchWithGenesysModalComponent.vue?vue&type=template&id=6a4e48bd&scoped=true&"
import script from "./LinkChurchWithGenesysModalComponent.vue?vue&type=script&lang=js&"
export * from "./LinkChurchWithGenesysModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e48bd",
  null
  
)

export default component.exports